// semeia-disable-reexport
import { get } from "@ember/object";

export function sortAsc(a: number | string | Date, b: number | string | Date) {
  if (a > b) return 1;
  else if (a < b) return -1;
  return 0;
}

export function sortDesc(a: number | string | Date, b: number | string | Date) {
  return sortAsc(a, b) * -1;
}

export function sortBy(key: string, direction = "asc") {
  return function (a, b) {
    if (direction === "asc") return sortAsc(get(a, key), get(b, key));
    return sortDesc(get(a, key), get(b, key));
  };
}
